import { render, staticRenderFns } from "./ImagePlusOutline.vue?vue&type=template&id=243b8b16"
import script from "./ImagePlusOutline.vue?vue&type=script&lang=js"
export * from "./ImagePlusOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports